import { OptionStringValues, OptionTypes } from "types/common";
import moment from "moment";

export const FilterStatusOptions: OptionTypes[] = [
  { name: "Succeeded", value: "Succeeded" },
  { name: "Failed", value: "Failed" },
  { name: "Refunded", value: "Refunded" },
  { name: "Partial refund", value: "Partial refund" },
  { name: "Disputed", value: "Disputed" },
  { name: "Voided", value: "Voided" },
  { name: "Pending", value: "Pending" },
  // { name: "Disputed won", value: "Disputed won" },
  // { name: "Disputed lost", value: "Disputed lost" },
  { name: "Incomplete", value: "Incomplete" },
];

export const ActionCenterStatusOptions: OptionTypes[] = [
  { name: "Open", value: "Open" },
  { name: "Completed", value: "Completed" },
  { name: "Past Due", value: "Past Due" },
  { name: "Expired", value: "Expired" },
  { name: "Canceled", value: "Canceled" },
];

export const SubscriptionsStatusOptions: OptionTypes[] = [
  { name: "Active", value: `Active` },
  { name: "Past Due", value: "Past Due" },
  { name: "Unpaid", value: "Unpaid" },
  { name: "Incomplete", value: "Incomplete" },
  { name: "Completed", value: "Completed" },
  { name: "Canceled", value: "Canceled" },
];

const FilterMethodOptions: OptionTypes[] = [
  { name: "Card", value: "Card" },
  { name: "Bank", value: "Bank" },
  { name: "PayPal", value: "PayPal" },
  { name: "Cash App Pay", value: "Cash App Pay" },
  { name: "Amazon Pay", value: "Amazon Pay" },
  { name: "Google Pay", value: "Google Pay" },
  { name: "Apple Pay", value: "Apple Pay" },
];

export const PaymentFilterMethodOptions: OptionTypes[] = [
  { name: "Card", value: "Card" },
  { name: "Bank", value: "Bank" },
  { name: "PayPal", value: "PayPal" },
  { name: "Wire Transfer", value: "Wire Transfer" },
  { name: "Cash App Pay", value: "Cash App Pay" },
  { name: "Amazon Pay", value: "Amazon Pay" },
  { name: "Google Pay", value: "Google Pay" },
  { name: "Apple Pay", value: "Apple Pay" },
  { name: "Cash", value: "Cash" },
  { name: "Check", value: "Check" },
  { name: "Invoice", value: "Invoice" },
];

export const TypeFilter: OptionStringValues[] = [
  { name: "Payment Agreement", value: "Payment Agreement" },
  { name: "Payment Link", value: "Payment Link" },
  { name: "Invoice", value: "Invoice" },
  { name: "Quote", value: "Quote" },
];

export const FilterAmountOptions: OptionStringValues[] = [
  { name: "is equal to", value: "isEqual", label: "Exactly" },
  { name: "is between", value: "isBetween", label: "" },
  { name: "is greater than", value: "greaterThan", label: "More than" },
  { name: "is less than", value: "lessThan", label: "Less than" },
];

export const FilterDateOptions: OptionStringValues[] = [
  { name: "is in the last", value: "isInLast", label: "In Last" },
  { name: "is equal to", value: "isEqual", label: "Exactly on" },
  { name: "is between", value: "isBetween", label: "" },
  { name: "is on or after", value: "lessThan", label: "On or after" },
  { name: "is before", value: "lessThan", label: "Before" },
];

const DaySelector: OptionStringValues[] = [
  { name: "days", value: "days", label: "Days" },
  { name: "months", value: "months", label: "Months" },
  { name: "hours", value: "hours", label: "Hours" },
];

export const PlanDetailsFilterList: OptionStringValues[] = [
  { name: "Daily", value: "day" },
  { name: "Monthly", value: "month" },
  { name: "Weekly", value: "week" },
  { name: "Yearly", value: "year" },
  { name: "Every 3 months", value: "quarter" },
  { name: "Every 6 months", value: "semiannual" },
  { name: "Custom", value: "custom" },
];

export const timeRanges: Record<string, [Date, Date]> = {
  Today: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
  Yesterday: [
    moment().subtract(1, "days").startOf("day").toDate(),
    moment().subtract(1, "days").endOf("day").toDate(),
  ],
  "This week": [
    moment().startOf("week").toDate(),
    moment().endOf("week").toDate(),
  ],
  "Last week": [
    moment().subtract(1, "week").startOf("week").toDate(),
    moment().subtract(1, "week").endOf("week").toDate(),
  ],
  "Month-to-date": [
    moment().startOf("month").toDate(),
    moment().endOf("day").toDate(),
  ],
  "Last month": [
    moment().subtract(1, "month").startOf("month").toDate(),
    moment().subtract(1, "month").endOf("month").toDate(),
  ],
};

export const scheduledFilterTimeRanges = {
  "This Month": [
    moment().startOf("month").toDate(),
    moment().endOf("month").toDate(),
  ],
  "Next Month": [
    moment().add(1, "months").startOf("month").toDate(),
    moment().add(1, "months").endOf("month").toDate(),
  ],
  "Next 3 Months": [
    moment().add(1, "months").startOf("month").toDate(),
    moment().add(3, "months").endOf("month").toDate(),
  ],
};

export const scheduledTimeRanges: Record<string, [Date, Date]> = {
  Today: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
  Tomorrow: [
    moment().add(1, "days").startOf("day").toDate(),
    moment().add(1, "days").endOf("day").toDate(),
  ],
  "Next week": [
    moment().add(1, "week").startOf("week").toDate(),
    moment().add(1, "week").endOf("week").toDate(),
  ],
  "Next 7 days": [
    moment().startOf("day").toDate(),
    moment().add(7, "days").endOf("day").toDate(),
  ],
  "Next month": [
    moment().add(1, "months").startOf("month").toDate(),
    moment().add(1, "months").endOf("month").toDate(),
  ],
  "Next 30 days": [
    moment().startOf("day").toDate(),
    moment().add(30, "days").endOf("day").toDate(),
  ],
};

export const BUDGET_EXPENSE_OPTION: OptionTypes[] = [
  { name: "Housing", value: "Housing" },
  { name: "Transportation", value: "Transportation" },
  { name: "Education", value: "Education" },
  { name: "Food & Personal", value: "Food & Personal" },
  { name: "Monthly Savings", value: "Monthly Savings" },
  { name: "Other", value: "Other" },
];

export const BUDGET_INCOME_OPTION: OptionTypes[] = [
  { name: "Salary/Wages", value: "Salary/Wages" },
  { name: "Other Income", value: "Other Income" },
];
